<template>
  <div class="maxwell-wheel-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>mgh + 1/2 mv² + 1/2 Iω² = Const$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Strings -->
          <line x1="180" y1="20" x2="180" :y2="wheelY" stroke="#888" stroke-width="1" />
          <line x1="220" y1="20" x2="220" :y2="wheelY" stroke="#888" stroke-width="1" />
          
          <!-- The Wheel -->
          <g :transform="`translate(200, ${wheelY})`">
             <!-- Axle -->
             <rect x="-30" y="-5" width="60" height="10" fill="#666" />
             <!-- The Heavy Disk -->
             <circle r="40" fill="#333" stroke="#888" stroke-width="3" />
             <g :transform="`rotate(${angle})`">
                <line x1="-35" y1="0" x2="35" y2="0" stroke="#ffd700" stroke-width="2" />
                <circle cx="25" cy="0" r="3" fill="#ffd700" />
             </g>
          </g>

          <!-- Top Support -->
          <rect x="150" y="10" width="100" height="10" fill="#222" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>能量转换: {{ direction > 0 ? '势能 → 动能 (转动)' : '动能 (转动) → 势能' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="reset">重新释放</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>麦克斯韦滚摆是研究**机械能守恒**的经典仪器。当滚摆下降时，由于轴上的细线被拉开，滚摆不仅在平动，还在快速转动，重力势能转化为平动动能和**转动动能**。当到达底部时，强大的转动惯性会使细线重新反向缠绕，将滚摆再次拉起。它展示了转动动能在能量存储中的重要作用。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaxwellsWheelViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      wheelY: 40,
      angle: 0,
      velocity: 0,
      direction: 1, // 1 for down, -1 for up
      timer: null
    }
  },
  methods: {
    update() {
       if (this.direction > 0) {
          this.velocity = Math.min(2, this.velocity + 0.05);
          this.wheelY += this.velocity;
          this.angle += this.velocity * 10;
          if (this.wheelY > 200) {
             this.direction = -1;
             this.velocity *= 0.95; // Loss
          }
       } else {
          this.velocity -= 0.05;
          this.wheelY -= this.velocity;
          this.angle += this.velocity * 10;
          if (this.velocity <= 0) {
             this.direction = 1;
             this.velocity = 0;
          }
       }
       this.timer = requestAnimationFrame(this.update);
    },
    reset() {
       this.wheelY = 40;
       this.velocity = 0;
       this.direction = 1;
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.maxwell-wheel-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
